var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81016 12.1908C9.01433 15.395 11.9835 15.7458 12.8552 15.7783C13.9085 15.8167 14.9835 14.9567 15.4485 14.0758C14.7068 13.2058 13.741 12.5308 12.6827 11.7992C12.0593 12.4225 11.291 13.5808 10.266 13.1658C9.6835 12.9317 8.24516 12.2692 6.9885 11.0117C5.731 9.755 5.06933 8.31667 4.8335 7.735C4.4185 6.70917 5.58016 5.93833 6.20433 5.31417C5.47266 4.23917 4.80933 3.24833 3.941 2.54417C3.04766 3.01083 2.18266 4.0775 2.22183 5.145C2.25433 6.01667 2.60516 8.98583 5.81016 12.1908ZM12.7935 17.4433C11.5935 17.3992 8.19266 16.93 4.631 13.3683C1.07016 9.8075 0.600996 6.4075 0.555996 5.20667C0.489329 3.37667 1.891 1.59917 3.51016 0.905C3.70514 0.820806 3.91866 0.788751 4.12977 0.81198C4.34088 0.835209 4.54232 0.912925 4.71433 1.0375C6.05433 2.015 6.9785 3.49583 7.77266 4.65583C7.93787 4.89704 8.01355 5.18842 7.98662 5.47954C7.95968 5.77066 7.83182 6.0432 7.62516 6.25L6.49516 7.38083C6.75766 7.96 7.29183 8.95833 8.16683 9.83333C9.04183 10.7083 10.0402 11.2425 10.6202 11.505L11.7493 10.375C11.9569 10.1679 12.2306 10.0402 12.5227 10.0142C12.8148 9.98813 13.1067 10.0654 13.3477 10.2325C14.531 11.0525 15.921 11.9633 16.9343 13.2608C17.069 13.4341 17.1547 13.6403 17.1824 13.858C17.2101 14.0757 17.1788 14.2969 17.0918 14.4983C16.3943 16.1258 14.6293 17.5108 12.7935 17.4433Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.924aa1e7c7705af167fa90a4ec1cc040.svg";
export { ForwardRef as ReactComponent };